/* Publish by EComposer at 2026-10-21 11:58:32*/
;try{
 (function(){
  'use strict';

  if(window.__astroyaAscCityBoot) return;

  var GEO_URL = 'https://geocoding-api.open-meteo.com/v1/search';
  var MIN_CHARS = 2;
  var DEBOUNCE = 280;

  var booted = false;

  function boot(){
    if(booted) return true;

    var search = document.getElementById('birth-city-search');
    var list   = document.getElementById('birth-city-list');
    var group  = search ? search.closest('.asc-city-group') : null;

    if(!search || !list) return false;

    booted = true;
    window.__astroyaAscCityBoot = true;

    if(list.parentNode !== document.body){
      document.body.appendChild(list);
    }
    if(!list.innerHTML){ list.innerHTML = '\u200B'; }

    var timer = null;
    var lastQuery = '';
    var activeIndex = -1;
    var currentResults = [];
    var isOpen = false;

    function $(id){ return document.getElementById(id); }

    function setHidden(lat, name, lng, tz, country){
      var f;
      f = $('birth-lat');          if(f) f.value = (lat === null ? '' : String(lat));
      f = $('birth-city-name');    if(f) f.value = name || '';
      f = $('birth-city-lng');     if(f) f.value = (lng === null ? '' : String(lng));
      f = $('birth-city-tz');      if(f) f.value = tz || '';
      f = $('birth-city-country'); if(f) f.value = country || '';
    }

    function clearSelection(){
      setHidden(null, '', null, '', '');
      if(group) group.classList.remove('asc-city-ok');
    }

    function setLoading(on){
      if(!group) return;
      if(on) group.classList.add('asc-city-loading');
      else group.classList.remove('asc-city-loading');
    }

    function placeList(){
      if(!isOpen) return;
      var r = search.getBoundingClientRect();
      list.style.left  = r.left + 'px';
      list.style.width = r.width + 'px';

      var spaceBelow = window.innerHeight - r.bottom;
      var wanted = Math.min(list.scrollHeight || 240, 260);

      if(spaceBelow < wanted + 12 && r.top > wanted + 12){
        list.style.top = (r.top - wanted - 5) + 'px';
        list.style.maxHeight = wanted + 'px';
      } else {
        list.style.top = (r.bottom + 5) + 'px';
        list.style.maxHeight = Math.max(120, Math.min(wanted, spaceBelow - 14)) + 'px';
      }
    }

    function openList(){
      isOpen = true;
      list.style.display = 'block';
      search.setAttribute('aria-expanded', 'true');
      placeList();
    }

    function closeList(){
      isOpen = false;
      list.style.display = 'none';
      search.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function highlight(idx){
      var opts = list.querySelectorAll('.asc-city-opt');
      var i;
      for(i = 0; i < opts.length; i++){ opts[i].classList.remove('asc-active'); }
      if(idx >= 0 && idx < opts.length){
        opts[idx].classList.add('asc-active');
        if(opts[idx].scrollIntoView){ opts[idx].scrollIntoView({block:'nearest'}); }
      }
      activeIndex = idx;
    }

    function choose(p){
      var label = p.name;
      if(p.country){ label += ', ' + p.country; }
      search.value = label;
      setHidden(p.latitude, p.name, p.longitude, p.timezone || '', p.country || '');
      if(group) group.classList.add('asc-city-ok');
      closeList();

      var errBox = $('calc-error');
      if(errBox){ errBox.classList.remove('active'); }
    }

    function esc(str){
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function render(results){
      currentResults = results || [];
      activeIndex = -1;

      if(!currentResults.length){
        list.innerHTML = '<div class="asc-city-empty">Aucune ville trouv\u00e9e. Essaie sans accent, ou la grande ville la plus proche.</div>';
        openList();
        return;
      }

      var html = '';
      var i, p, sub;
      for(i = 0; i < currentResults.length; i++){
        p = currentResults[i];
        sub = [];
        if(p.admin1){ sub.push(p.admin1); }
        if(p.country){ sub.push(p.country); }

        html += '<div class="asc-city-opt" role="option" data-idx="' + i + '">'
             +  '<span class="asc-city-main">' + esc(p.name) + '</span>'
             +  (sub.length ? ' <span class="asc-city-sub">' + esc(sub.join(', ')) + '</span>' : '')
             +  '</div>';
      }
      list.innerHTML = html;
      openList();
    }

    function fetchCities(q){
      var url = GEO_URL + '?count=8&language=fr&format=json&name=' + encodeURIComponent(q);
      setLoading(true);

      fetch(url)
        .then(function(r){ return r.json(); })
        .then(function(d){
          setLoading(false);
          if(search.value.trim() !== q) return;
          render((d && d.results) ? d.results : []);
        })
        .catch(function(){
          setLoading(false);
          list.innerHTML = '<div class="asc-city-empty">Recherche indisponible. V\u00e9rifie ta connexion.</div>';
          openList();
        });
    }

    search.addEventListener('input', function(){
      clearSelection();
      var q = search.value.trim();
      clearTimeout(timer);

      if(q.length < MIN_CHARS){
        setLoading(false);
        closeList();
        return;
      }
      lastQuery = q;
      timer = setTimeout(function(){
        if(search.value.trim() === lastQuery){ fetchCities(lastQuery); }
      }, DEBOUNCE);
    });

    list.addEventListener('mousedown', function(e){
      var opt = e.target.closest ? e.target.closest('.asc-city-opt') : null;
      if(!opt) return;
      e.preventDefault();
      var idx = parseInt(opt.getAttribute('data-idx'), 10);
      if(!isNaN(idx) && currentResults[idx]){ choose(currentResults[idx]); }
    });

    list.addEventListener('touchstart', function(e){
      var opt = e.target.closest ? e.target.closest('.asc-city-opt') : null;
      if(!opt) return;
      var idx = parseInt(opt.getAttribute('data-idx'), 10);
      if(!isNaN(idx) && currentResults[idx]){
        e.preventDefault();
        choose(currentResults[idx]);
      }
    }, {passive:false});

    search.addEventListener('keydown', function(e){
      if(!isOpen || !currentResults.length){
        if(e.key === 'ArrowDown' && search.value.trim().length >= MIN_CHARS){
          fetchCities(search.value.trim());
        }
        return;
      }
      if(e.key === 'ArrowDown'){
        e.preventDefault();
        highlight(activeIndex + 1 >= currentResults.length ? 0 : activeIndex + 1);
      } else if(e.key === 'ArrowUp'){
        e.preventDefault();
        highlight(activeIndex - 1 < 0 ? currentResults.length - 1 : activeIndex - 1);
      } else if(e.key === 'Enter'){
        if(activeIndex >= 0 && currentResults[activeIndex]){
          e.preventDefault();
          choose(currentResults[activeIndex]);
        }
      } else if(e.key === 'Escape'){
        closeList();
      }
    });

    document.addEventListener('click', function(e){
      if(e.target === search) return;
      if(list.contains(e.target)) return;
      closeList();
    });

    window.addEventListener('scroll', placeList, true);
    window.addEventListener('resize', placeList);
    window.addEventListener('orientationchange', function(){ setTimeout(placeList, 220); });

    /* API publique : pre-remplissage depuis le panel "Mon Astroya" */
    window.AstroyaAscCity = {
      set: function(name, lat, lng, tz, country){
        if(!name || lat === undefined || lat === null) return false;
        search.value = country ? (name + ', ' + country) : name;
        setHidden(lat, name, (lng === undefined ? null : lng), tz || '', country || '');
        if(group) group.classList.add('asc-city-ok');
        return true;
      },
      get: function(){
        var latEl = $('birth-lat');
        var nameEl = $('birth-city-name');
        return {
          name: nameEl ? nameEl.value : '',
          lat: latEl && latEl.value ? parseFloat(latEl.value) : null
        };
      },
      clear: function(){
        search.value = '';
        clearSelection();
        closeList();
      }
    };

    return true;
  }

  var tries = 0;
  var iv = setInterval(function(){
    tries++;
    if(boot() || tries >= 40){ clearInterval(iv); }
  }, 150);

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);

  if(window.MutationObserver){
    var mo = new MutationObserver(function(){
      if(boot() && mo){ mo.disconnect(); }
    });
    if(document.body){
      mo.observe(document.body, {childList:true, subtree:true});
    }
  }
})();

/* ==================================================================
   MODULE 1 - CALCULATEUR D'ASCENDANT + LECTURE DETAILLEE (n8n)
   Calcul astronomique IDENTIQUE a la page theme astral (temps sideral,
   latitude, longitude, fuseau et heure d'ete historiques).
   Repli sur l'ancienne methode si la ville n'a pas de longitude.
   Lecture detaillee offerte avec la newsletter : aucune cle ni liste
   e-mail dans la page, tout passe par n8n.
   ================================================================== */
(function(){
  if(window.__astroyaAscV2) return;

  var API = 'https://n8n.astroya.fr/webhook/ascendant';
  var SCROLL_OFFSET = 220;
  var K_EMAIL = 'astroya_asc_email', K_TOKEN = 'astroya_asc_token', COOKIE_DAYS = 400;
  var PREFILL_KEYS = ['astroya_tha_email','astroya_horo_email','astroya_pdn_email','astroya_rbi_email','astroya_qpl_email','astroya_cam_email','astroya_tcb_email','astroya_adj_email','astroya_ang_email','astroya_aog_email','astroya_tan_email','astroya_oge_email','astroya_tdg_email','astroya_tdd_email','astroya_rnt_email','astroya_runes_email','astroya_lnd_email','astroya_ttm_email','astroya_tarologie_email','astroya_t3c_email','astroya_bel_email','astroya_ral_email','astroya_newsletter_email','astroya_amour_email_v2','astroya_boule_email_v2','astroya_pendule_email_v2','astroya_tarot_oui_non_email_v2'];

  function astroyaTrack(name, params){ try{ if(typeof gtag === 'function'){ gtag('event', name, params || {}); } }catch(e){} }
  function $(id){ return document.getElementById(id); }
  function esc(v){ return String(v == null ? '' : v).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  var IMG_BASE = 'https://www.astroya.fr/cdn/shop/files/';
  var SIGNS = [
    {name:'B\u00e9lier', image: IMG_BASE + 'ascendant-belier.webp', element:'Feu', stones:'Jaspe rouge & H\u00e9matite',
     desc:'Ton ascendant B\u00e9lier te donne une pr\u00e9sence dynamique et conqu\u00e9rante. Tu abordes les nouvelles situations avec enthousiasme et un brin d\'impatience. Les autres te per\u00e7oivent comme une personne franche, directe, qui n\'a pas peur de prendre l\'initiative.|Le jaspe rouge ancre ton \u00e9nergie de feu pour \u00e9viter l\'\u00e9puisement, tandis que l\'h\u00e9matite t\'aide \u00e0 canaliser ton \u00e9lan vers des actions r\u00e9fl\u00e9chies plut\u00f4t qu\'impulsives.'},
    {name:'Taureau', image: IMG_BASE + 'ascendant-taureau.webp', element:'Terre', stones:'Aventurine verte & Quartz rose',
     desc:'Ton ascendant Taureau te conf\u00e8re une pr\u00e9sence pos\u00e9e, sensuelle et rassurante. Tu d\u00e9gages une stabilit\u00e9 naturelle qui inspire confiance. Ta d\u00e9marche est tranquille, ton \u00e9l\u00e9gance \u00e9vidente.|L\'aventurine verte amplifie ton magn\u00e9tisme tranquille, et le quartz rose ouvre ton c\u0153ur aux plaisirs simples qui font ta nature profonde.'},
    {name:'G\u00e9meaux', image: IMG_BASE + 'ascendant-gemeaux.webp', element:'Air', stones:'Citrine & Aigue-marine',
     desc:'Ton ascendant G\u00e9meaux fait de toi une personne vive, curieuse, expressive. Tes gestes sont rapides, ton regard p\u00e9tille, tu parles avec aisance. Les autres te per\u00e7oivent comme quelqu\'un d\'intelligent, sociable et un peu insaisissable.|La citrine clarifie ton mental rapide, l\'aigue-marine apaise tes pens\u00e9es trop nombreuses pour te permettre des \u00e9changes plus profonds.'},
    {name:'Cancer', image: IMG_BASE + 'ascendant-cancer.webp', element:'Eau', stones:'Pierre de lune & Calc\u00e9doine',
     desc:'Ton ascendant Cancer dessine une silhouette douce et un regard r\u00eaveur. Tu d\u00e9gages une \u00e9motivit\u00e9 protectrice qui attire naturellement la confidence. Les autres se sentent en s\u00e9curit\u00e9 avec toi, comme dans un cocon.|La pierre de lune harmonise tes cycles \u00e9motionnels intenses, la calc\u00e9doine renforce ta douceur sans t\'\u00e9puiser dans les \u00e9motions des autres.'},
    {name:'Lion', image: IMG_BASE + 'ascendant-lion.webp', element:'Feu', stones:'Citrine & \u0152il de tigre',
     desc:'Ton ascendant Lion te donne un rayonnement naturel et un charisme \u00e9vident. Tu entres quelque part et les t\u00eates se tournent. Ta prestance est instinctive, ta fiert\u00e9 se voit dans ton maintien droit.|La citrine amplifie ta lumi\u00e8re solaire, l\'\u0153il de tigre te prot\u00e8ge des jalousies que ton \u00e9clat peut susciter.'},
    {name:'Vierge', image: IMG_BASE + 'ascendant-vierge.webp', element:'Terre', stones:'Amazonite & Cornaline',
     desc:'Ton ascendant Vierge cr\u00e9e une apparence sobre, \u00e9l\u00e9gante et m\u00e9thodique. Tu projettes de la pr\u00e9cision, de l\'intelligence pratique, parfois une r\u00e9serve qui peut sembler froide mais cache une grande g\u00e9n\u00e9rosit\u00e9.|L\'amazonite apaise ta tendance \u00e0 trop analyser, la cornaline ravive ton \u00e9lan quand tu te perds dans les d\u00e9tails.'},
    {name:'Balance', image: IMG_BASE + 'ascendant-balance.webp', element:'Air', stones:'Quartz rose & Jade',
     desc:'Ton ascendant Balance te conf\u00e8re un charme harmonieux et une gr\u00e2ce naturelle. Tu cherches l\'esth\u00e9tique, la justesse, l\'\u00e9quilibre dans chaque relation. Les autres te trouvent diplomate et agr\u00e9able \u00e0 fr\u00e9quenter.|Le quartz rose nourrit ton besoin profond d\'harmonie, le jade t\'apporte la sagesse de poser des limites sans rompre le lien.'},
    {name:'Scorpion', image: IMG_BASE + 'ascendant-scorpion.webp', element:'Eau', stones:'Malachite & Obsidienne',
     desc:'Ton ascendant Scorpion te donne un magn\u00e9tisme intense, un regard per\u00e7ant qui voit au-del\u00e0 des apparences. Tu fascines ou tu intrigues, jamais tu ne laisses indiff\u00e9rent.|La malachite transforme tes \u00e9motions profondes en force cr\u00e9atrice, l\'obsidienne cr\u00e9e un bouclier \u00e9nerg\u00e9tique autour de toi.'},
    {name:'Sagittaire', image: IMG_BASE + 'ascendant-sagittaire.webp', element:'Feu', stones:'Lapis-lazuli & Am\u00e9thyste',
     desc:'Ton ascendant Sagittaire te donne une allure libre, voyageuse, optimiste. Tu ris fort, tu vois grand, tu inspires ceux qui t\'entourent par ta foi en l\'avenir.|Le lapis-lazuli accompagne ta soif de v\u00e9rit\u00e9, l\'am\u00e9thyste \u00e9l\u00e8ve ta qu\u00eate de sens vers une spiritualit\u00e9 incarn\u00e9e.'},
    {name:'Capricorne', image: IMG_BASE + 'ascendant-capricorne.webp', element:'Terre', stones:'Quartz fum\u00e9 & Onyx noir',
     desc:'Ton ascendant Capricorne projette du s\u00e9rieux, de la structure, une autorit\u00e9 tranquille. On te confie naturellement des responsabilit\u00e9s. Ta distance est en r\u00e9alit\u00e9 une grande pudeur.|Le quartz fum\u00e9 ancre tes ambitions dans la dur\u00e9e, l\'onyx noir prot\u00e8ge ta d\u00e9termination des doutes qui te freinent parfois.'},
    {name:'Verseau', image: IMG_BASE + 'ascendant-verseau.webp', element:'Air', stones:'Am\u00e9thyste & Aigue-marine',
     desc:'Ton ascendant Verseau te donne une originalit\u00e9 visible, un style d\u00e9cal\u00e9, une distance c\u00e9r\u00e9brale qui intrigue. Tu es l\'ami fid\u00e8le mais impr\u00e9visible, l\'esprit libre qui pense diff\u00e9remment.|L\'am\u00e9thyste \u00e9l\u00e8ve tes intuitions visionnaires, l\'aigue-marine fluidifie tes relations en \u00e9quilibrant ton besoin de libert\u00e9 et celui des autres.'},
    {name:'Poissons', image: IMG_BASE + 'ascendant-poissons.webp', element:'Eau', stones:'Am\u00e9thyste & Pierre de lune',
     desc:'Ton ascendant Poissons te donne un regard doux et bienveillant, une pr\u00e9sence r\u00eaveuse, une grande sensibilit\u00e9. Tu absorbes les ambiances comme une \u00e9ponge, tu touches les autres par ta douceur.|L\'am\u00e9thyste prot\u00e8ge ton \u00e9nergie tr\u00e8s ouverte, la pierre de lune accompagne tes cycles \u00e9motionnels et ton intuition naturelle.'}
  ];

  /* ---------- NOYAU ASTRONOMIQUE (copie conforme de la page theme astral) ---------- */
  var D2R = Math.PI / 180, R2D = 180 / Math.PI;
  function norm360(x){ x = x % 360; return x < 0 ? x + 360 : x; }
  function julianDay(y, m, d, hUT){
    var Y = y, M = m;
    if(M <= 2){ Y = Y - 1; M = M + 12; }
    var A = Math.floor(Y / 100), B = 2 - A + Math.floor(A / 4);
    return Math.floor(365.25 * (Y + 4716)) + Math.floor(30.6001 * (M + 1)) + d + B - 1524.5 + hUT / 24;
  }
  function tzOffsetHours(tz, dateUTC){
    var dtf = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit' });
    var parts = dtf.formatToParts(dateUTC), o = {}, i;
    for(i = 0; i < parts.length; i++){ o[parts[i].type] = parts[i].value; }
    var asUTC = Date.UTC(+o.year, +o.month - 1, +o.day, (+o.hour) % 24, +o.minute, +o.second);
    return (asUTC - dateUTC.getTime()) / 3600000;
  }
  function localToUT(y, m, d, h, mi, tz, lng){
    var wall = Date.UTC(y, m - 1, d, h, mi, 0), off = 0;
    try{
      if(!tz || !window.Intl || !Intl.DateTimeFormat) throw new Error('no tz');
      off = tzOffsetHours(tz, new Date(wall));
      off = tzOffsetHours(tz, new Date(wall - off * 3600000));
    }catch(e){ off = Math.round(lng / 15); }
    var u = new Date(wall - off * 3600000);
    return { y: u.getUTCFullYear(), m: u.getUTCMonth() + 1, d: u.getUTCDate(), h: u.getUTCHours() + u.getUTCMinutes() / 60 + u.getUTCSeconds() / 3600, offset: off };
  }
  function obliquity(T){ return 23.4392911 - 0.0130042 * T - 0.00000016 * T * T + 0.000000504 * T * T * T; }
  function sunLongitude(T){
    var L = 280.46646 + 36000.76983 * T + 0.0003032 * T * T;
    var M = 357.52911 + 35999.05029 * T - 0.0001537 * T * T, Mr = M * D2R;
    var C = (1.914602 - 0.004817 * T - 0.000014 * T * T) * Math.sin(Mr) + (0.019993 - 0.000101 * T) * Math.sin(2 * Mr) + 0.000289 * Math.sin(3 * Mr);
    return norm360(L + C);
  }
  function moonLongitude(T){
    var Lp = 218.3164477 + 481267.88123421 * T - 0.0015786 * T * T + T * T * T / 538841;
    var D  = 297.8501921 + 445267.1114034 * T - 0.0018819 * T * T;
    var M  = 357.5291092 + 35999.0502909 * T - 0.0001536 * T * T;
    var Mp = 134.9633964 + 477198.8675055 * T + 0.0087414 * T * T;
    var F  = 93.2720950 + 483202.0175233 * T - 0.0036539 * T * T;
    var d = D * D2R, m = M * D2R, mp = Mp * D2R, f = F * D2R;
    var s = 6.288774 * Math.sin(mp) + 1.274027 * Math.sin(2*d - mp) + 0.658314 * Math.sin(2*d) + 0.213618 * Math.sin(2*mp)
          - 0.185116 * Math.sin(m) - 0.114332 * Math.sin(2*f) + 0.058793 * Math.sin(2*d - 2*mp) + 0.057066 * Math.sin(2*d - m - mp)
          + 0.053322 * Math.sin(2*d + mp) + 0.045758 * Math.sin(2*d - m) - 0.040923 * Math.sin(m - mp) - 0.034720 * Math.sin(d)
          - 0.030383 * Math.sin(m + mp) + 0.015327 * Math.sin(2*d - 2*f) - 0.012528 * Math.sin(mp + 2*f) + 0.010980 * Math.sin(mp - 2*f)
          + 0.010675 * Math.sin(4*d - mp) + 0.010034 * Math.sin(3*mp) + 0.008548 * Math.sin(4*d - 2*mp) - 0.007888 * Math.sin(2*d + m - mp)
          - 0.006766 * Math.sin(2*d + m) - 0.005163 * Math.sin(d - mp) + 0.004987 * Math.sin(d + m) + 0.004036 * Math.sin(2*d - m + mp)
          + 0.003994 * Math.sin(2*d + 2*mp) + 0.003861 * Math.sin(4*d) + 0.003665 * Math.sin(2*d - 3*mp);
    return norm360(Lp + s);
  }
  var ELEMENTS = {
    earth: { a:[1.00000261, 0.00000562], e:[0.01671123, -0.00004392], i:[-0.00001531, -0.01294668], L:[100.46457166, 35999.37244981], w:[102.93768193, 0.32327364], O:[0, 0] },
    venus: { a:[0.72333566, 0.00000390], e:[0.00677672, -0.00004107], i:[3.39467605, -0.00078890], L:[181.97909950, 58517.81538729], w:[131.60246718, 0.00268329], O:[76.67984255, -0.27769418] },
    mars:  { a:[1.52371034, 0.00001847], e:[0.09339410, 0.00007882], i:[1.84969142, -0.00813131], L:[-4.55343205, 19140.30268499], w:[-23.94362959, 0.44441088], O:[49.55953891, -0.29257343] }
  };
  function helioVector(key, T){
    var p = ELEMENTS[key];
    var a = p.a[0] + p.a[1] * T, e = p.e[0] + p.e[1] * T, inc = (p.i[0] + p.i[1] * T) * D2R;
    var L = p.L[0] + p.L[1] * T, wbar = p.w[0] + p.w[1] * T, O = p.O[0] + p.O[1] * T;
    var M = norm360(L - wbar); if(M > 180){ M -= 360; }
    var Mr = M * D2R, E = Mr + e * Math.sin(Mr), dE, k;
    for(k = 0; k < 12; k++){ dE = (E - e * Math.sin(E) - Mr) / (1 - e * Math.cos(E)); E -= dE; if(Math.abs(dE) < 1e-11) break; }
    var xv = a * (Math.cos(E) - e), yv = a * Math.sqrt(1 - e * e) * Math.sin(E);
    var om = (wbar - O) * D2R, Or = O * D2R;
    var co = Math.cos(om), so = Math.sin(om), cO = Math.cos(Or), sO = Math.sin(Or), ci = Math.cos(inc), si = Math.sin(inc);
    return { x: xv * (co * cO - so * sO * ci) - yv * (so * cO + co * sO * ci), y: xv * (co * sO + so * cO * ci) + yv * (co * cO * ci - so * sO), z: xv * (so * si) + yv * (co * si) };
  }
  function geoLongitude(key, T){
    var earth = helioVector('earth', T), pl = helioVector(key, T), dx, dy, dz, dist, tau, i;
    for(i = 0; i < 2; i++){ dx = pl.x - earth.x; dy = pl.y - earth.y; dz = pl.z - earth.z; dist = Math.sqrt(dx*dx + dy*dy + dz*dz); tau = dist / 173.1446327; pl = helioVector(key, T - tau / 36525); }
    dx = pl.x - earth.x; dy = pl.y - earth.y;
    return norm360(R2D * Math.atan2(dy, dx) + 1.396971 * T + 0.0003086 * T * T);
  }
  function ascendantMC(T, jdUT, hUT, lat, lng){
    var T0 = (Math.floor(jdUT - 0.5) + 0.5 - 2451545.0) / 36525.0;
    var GST0 = 6.697374558 + 2400.051336 * T0 + 0.000025862 * T0 * T0; GST0 = ((GST0 % 24) + 24) % 24;
    var GST = GST0 + hUT * 1.00273790935, LST = ((GST + lng / 15) % 24 + 24) % 24, RAMC = LST * 15;
    var phi = Math.max(-66, Math.min(66, lat)) * D2R, eps = obliquity(T) * D2R, r = RAMC * D2R;
    var asc = Math.atan2(Math.cos(r), -(Math.sin(r) * Math.cos(eps) + Math.tan(phi) * Math.sin(eps)));
    var mc = Math.atan2(Math.sin(r), Math.cos(r) * Math.cos(eps));
    return { asc: norm360(asc * R2D), mc: norm360(mc * R2D), ramc: RAMC };
  }
  function signIndex(lon){ return Math.floor(norm360(lon) / 30) % 12; }
  function degInSign(lon){ return norm360(lon) - signIndex(lon) * 30; }
  function formatDeg(lon){
    var deg = degInSign(lon), d = Math.floor(deg), mn = Math.round((deg - d) * 60);
    if(mn === 60){ mn = 0; d += 1; }
    return d + '\u00b0' + (mn < 10 ? '0' : '') + mn + '\u2032';
  }
  function computeChart(dateStr, timeStr, lat, lng, tz){
    var dparts = String(dateStr).split('-'), tparts = String(timeStr).split(':');
    var y = parseInt(dparts[0], 10), mo = parseInt(dparts[1], 10), da = parseInt(dparts[2], 10), hh = parseInt(tparts[0], 10), mm = parseInt(tparts[1], 10);
    if(isNaN(y) || isNaN(mo) || isNaN(da) || isNaN(hh) || isNaN(mm)){ throw new Error('date/heure invalide'); }
    var ut = localToUT(y, mo, da, hh, mm, tz, lng);
    var jd = julianDay(ut.y, ut.m, ut.d, ut.h), T = (jd - 2451545.0) / 36525.0;
    var sunLon = sunLongitude(T), moonLon = moonLongitude(T), venusLon = geoLongitude('venus', T), marsLon = geoLongitude('mars', T);
    var am = ascendantMC(T, jd, ut.h, lat, lng);
    return {
      sunLon: sunLon, sunIdx: signIndex(sunLon), moonLon: moonLon, moonIdx: signIndex(moonLon),
      ascLon: am.asc, ascIdx: signIndex(am.asc), mcLon: am.mc, mcIdx: signIndex(am.mc),
      venusLon: venusLon, venusIdx: signIndex(venusLon), marsLon: marsLon, marsIdx: signIndex(marsLon),
      utOffset: ut.offset, jd: jd
    };
  }


  /* ---------- ancienne methode (repli si la ville n'a pas de longitude) ---------- */
  var ASC_SHIFT = function(sun, slot){ return (sun + slot) % 12; };
  function getSunSign(month, day){
    if((month===3 && day>=21) || (month===4 && day<=19))  return 0;
    if((month===4 && day>=20) || (month===5 && day<=20))  return 1;
    if((month===5 && day>=21) || (month===6 && day<=21))  return 2;
    if((month===6 && day>=22) || (month===7 && day<=22))  return 3;
    if((month===7 && day>=23) || (month===8 && day<=22))  return 4;
    if((month===8 && day>=23) || (month===9 && day<=22))  return 5;
    if((month===9 && day>=23) || (month===10 && day<=22)) return 6;
    if((month===10 && day>=23) || (month===11 && day<=21))return 7;
    if((month===11 && day>=22) || (month===12 && day<=21))return 8;
    if((month===12 && day>=22) || (month===1 && day<=19)) return 9;
    if((month===1 && day>=20) || (month===2 && day<=18))  return 10;
    return 11;
  }
  function getTimeSlot(hour, minute){ return Math.floor((((hour * 60 + minute) - 360 + 1440) % 1440) / 120); }

  /* calcule { asc, sun, deg, precise } */
  function computeAscendant(dateStr, timeStr, lat, lngRaw, tz){
    var lng = parseFloat(lngRaw);
    if(isFinite(lat) && isFinite(lng)){
      try{
        var c = computeChart(dateStr, timeStr, lat, lng, tz);
        if(isFinite(c.ascLon) && isFinite(c.sunLon)) return { asc: c.ascIdx, sun: c.sunIdx, deg: degInSign(c.ascLon), lon: c.ascLon, precise: true };
      }catch(e){}
    }
    var d = String(dateStr).split('-'), t = String(timeStr).split(':');
    var sun = getSunSign(parseInt(d[1], 10), parseInt(d[2], 10));
    return { asc: ASC_SHIFT(sun, getTimeSlot(parseInt(t[0], 10), parseInt(t[1], 10))), sun: sun, deg: null, lon: null, precise: false };
  }

  /* ---------- MEMOIRE (jeton signe + e-mail : localStorage + cookie .astroya.fr) ---------- */
  function cookieGet(k){ try{ var parts=document.cookie?document.cookie.split('; '):[]; for(var i=0;i<parts.length;i++){ var p=parts[i].split('='); if(p[0]===k) return decodeURIComponent(p.slice(1).join('=')); } }catch(e){} return ''; }
  function cookieSet(k,v){ try{ var dom=/(^|\.)astroya\.fr$/.test(location.hostname)?'; domain=.astroya.fr':''; var dt=new Date(); dt.setTime(dt.getTime()+COOKIE_DAYS*864e5);
    document.cookie=k+'='+encodeURIComponent(v)+'; expires='+dt.toUTCString()+'; path=/'+dom+'; SameSite=Lax'+(location.protocol==='https:'?'; Secure':''); }catch(e){} }
  function lsGet(k){ try{ return window.localStorage.getItem(k)||''; }catch(e){ return ''; } }
  function lsSet(k,v){ try{ window.localStorage.setItem(k,v); }catch(e){} }
  function store(k,v){ if(v){ lsSet(k,v); cookieSet(k,v); } }
  function readKey(k){ var v=lsGet(k)||cookieGet(k); if(v){ if(!lsGet(k)) lsSet(k,v); if(!cookieGet(k)) cookieSet(k,v); } return v; }
  function getAuth(){ return { email: readKey(K_EMAIL), token: readKey(K_TOKEN) }; }
  function saveAuth(email,token){ store(K_EMAIL,email); store(K_TOKEN,token); }
  function knownEmail(){ var a=getAuth(); if(a.email) return a.email; for(var i=0;i<PREFILL_KEYS.length;i++){ var v=lsGet(PREFILL_KEYS[i]); if(v) return v; } return ''; }
  function ask(payload){
    var ctrl=(typeof AbortController!=='undefined')?new AbortController():null;
    var timer=ctrl?setTimeout(function(){ ctrl.abort(); },15000):null;
    return fetch(API,{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload), signal:ctrl?ctrl.signal:undefined })
      .then(function(r){ if(!r.ok) throw new Error('http '+r.status); return r.json(); })
      .then(function(d){ if(timer) clearTimeout(timer); var data=(d&&d.length)?d[0]:d;
        if(!data||data.ok!==true){ var er=new Error('refus'); er.code=(data&&data.error)||''; throw er; } return data; })
      ['catch'](function(err){ if(timer) clearTimeout(timer); throw err; });
  }

  /* styles injectes : popup 2 ecrans + lecture detaillee */
  var CSS = ".hpm-modal{position:fixed !important;inset:0 !important;z-index:100001 !important;display:none !important;align-items:center !important;justify-content:center !important;padding:16px !important;box-sizing:border-box !important}.hpm-modal.hpm-open{display:flex !important}.hpm-modal *{box-sizing:border-box !important}.hpm-overlay{position:absolute !important;inset:0 !important;background:rgba(61,44,90,.72) !important;font-size:0 !important}.hpm-box{position:relative !important;z-index:1 !important;width:100% !important;max-width:400px !important;max-height:94vh !important;overflow-y:auto !important;background:linear-gradient(135deg,#fdf9f3 0%,#faf0ea 100%) !important;border:1px solid rgba(184,132,155,.45) !important;border-radius:12px !important;padding:26px 22px 20px !important;text-align:center !important;box-shadow:0 24px 60px rgba(61,44,90,.4) !important;animation:hpmIn .35s ease-out}@keyframes hpmIn{from{opacity:0;transform:translateY(10px) scale(.97)}to{opacity:1;transform:none} }.hpm-step{display:flex !important;flex-direction:column !important;gap:8px !important}.hpm-step[hidden]{display:none !important}.hpm-close{position:absolute !important;top:10px !important;right:10px !important;width:36px !important;height:36px !important;padding:0 !important;border:1px solid rgba(184,132,155,.4) !important;border-radius:50% !important;background:#fff !important;color:#6b4c8a !important;font-size:22px !important;line-height:1 !important;cursor:pointer !important}.hpm-title{font-family:\"El Messiri\",Georgia,serif !important;font-size:24px !important;font-weight:700 !important;line-height:1.25 !important;color:#3d2c5a !important;margin:0 !important;padding:0 40px !important}.hpm-text{font-family:Arial,Helvetica,sans-serif !important;font-size:15px !important;line-height:1.5 !important;color:#6a6080 !important;margin:0 0 6px !important}.hpm-field{width:100% !important;min-height:44px !important;padding:10px 14px !important;margin:0 !important;font-family:Arial,Helvetica,sans-serif !important;font-size:16px !important;text-align:center !important;color:#2b2b3d !important;background:#fff !important;border:1.5px solid rgba(184,132,155,.35) !important;border-radius:4px !important;-webkit-appearance:none !important;appearance:none !important;outline:none !important}.hpm-field:focus{border-color:#6b4c8a !important;box-shadow:0 0 0 3px rgba(107,76,138,.1) !important}.hpm-consent{display:flex !important;align-items:flex-start !important;gap:10px !important;padding:9px 11px !important;text-align:left !important;cursor:pointer !important;background:#fff !important;border:1px solid rgba(184,132,155,.35) !important;border-radius:6px !important;margin:0 !important}.hpm-consent input{flex-shrink:0 !important;width:18px !important;height:18px !important;margin:1px 0 0 !important;accent-color:#6b4c8a !important;cursor:pointer !important}.hpm-consent span{font-family:Arial,Helvetica,sans-serif !important;font-size:14px !important;line-height:1.45 !important;color:#3a3a4d !important}.hpm-consent.hpm-invalid{border-color:#9a3a5a !important;box-shadow:0 0 0 3px rgba(154,58,90,.18) !important}.hpm-btn{width:100% !important;margin:2px 0 0 !important;padding:14px 18px !important;border:none !important;border-radius:4px !important;cursor:pointer !important;font-family:Arial,Helvetica,sans-serif !important;font-size:16px !important;font-weight:700 !important;line-height:1.3 !important;letter-spacing:1px !important;text-transform:uppercase !important;color:#fff !important;background:linear-gradient(135deg,#6b4c8a 0%,#8a5ea8 100%) !important;box-shadow:0 6px 18px rgba(107,76,138,.28) !important}.hpm-btn:disabled{opacity:.6 !important;cursor:wait !important}.hpm-error{display:none !important;font-family:Arial,Helvetica,sans-serif !important;font-size:13.5px !important;line-height:1.45 !important;color:#9a3a5a !important;margin:0 !important}.hpm-error.hpm-show{display:block !important}.hpm-legal{font-family:Arial,Helvetica,sans-serif !important;font-size:11.5px !important;color:#8a7a9a !important;margin:2px 0 0 !important;line-height:1.45 !important}.hpm-legal a{color:#6b4c8a !important;text-decoration:underline !important}.hpm-astral{background:#fff !important;border:1px solid rgba(201,169,110,.5) !important;border-radius:8px !important;padding:14px !important;margin:2px 0 4px !important;box-shadow:0 6px 18px rgba(107,76,138,.1) !important}.hpm-astral-h{font-family:Arial,Helvetica,sans-serif !important;font-size:15.5px !important;font-weight:700 !important;line-height:1.4 !important;color:#3d2c5a !important;margin:0 0 10px !important}.hpm-astral-cta{display:block !important;padding:12px 16px !important;border-radius:4px !important;text-decoration:none !important;text-align:center !important;font-family:Arial,Helvetica,sans-serif !important;font-size:15px !important;font-weight:700 !important;letter-spacing:.5px !important;text-transform:uppercase !important;color:#3d2c5a !important;background:linear-gradient(135deg,#f0dca0,#c9a96e) !important;box-shadow:0 6px 16px rgba(201,169,110,.35) !important}body.hpm-lock{overflow:hidden !important}@media (max-width:600px){.hpm-title{font-size:21px !important}.hpm-text{font-size:14px !important}.hpm-btn{font-size:15px !important} }@media (max-height:640px){.hpm-box{padding:18px 16px 14px !important}.hpm-field{min-height:40px !important;padding:8px 12px !important} }" + "#astroya-ascendant-calc .asc-crumb{font-size:13px;color:#8a7a9a;margin:0 0 14px} #astroya-ascendant-calc .asc-crumb a{color:#6b4c8a;border-bottom:none} #astroya-ascendant-calc h2{font-size:28px;line-height:1.3} #astroya-ascendant-calc .asc-byline{text-align:center;font-size:12.5px;color:#8a7a9a;margin:-8px 0 18px} #astroya-ascendant-calc .asc-tablewrap{overflow-x:auto;-webkit-overflow-scrolling:touch} #astroya-ascendant-calc .asc-tablewrap .asc-table{min-width:520px} .asccta .asccta-title{display:block !important} #astroya-ascendant-calc .asc-lock{text-align:center;background:linear-gradient(135deg,#faf0ea,#fdf9f3);border:1px dashed #b8849b;border-radius:10px;padding:24px 20px;margin:0 0 24px} #astroya-ascendant-calc .asc-lock.asc-checking{opacity:.6} #astroya-ascendant-calc .asc-lock-eyebrow,#astroya-ascendant-calc .asc-deep-eyebrow{font-family:'El Messiri',Georgia,serif;font-size:12px;letter-spacing:4px;text-transform:uppercase;color:#a0825a;margin-bottom:6px} #astroya-ascendant-calc .asc-lock-title{font-family:'Poppins','Segoe UI',sans-serif;font-weight:600;font-size:22px;color:#3d2c5a;margin-bottom:12px} #astroya-ascendant-calc .asc-lock-items{display:flex;flex-wrap:wrap;gap:7px;justify-content:center;margin-bottom:16px} #astroya-ascendant-calc .asc-lock-items span{font-size:12.5px;font-weight:700;color:#6b4c8a;background:#fff;border:1px dashed rgba(107,76,138,.4);border-radius:20px;padding:5px 12px} #astroya-ascendant-calc .btn-calc.asc-unlock{display:inline-block;width:auto;letter-spacing:1px;padding:14px 28px} #astroya-ascendant-calc .asc-lock-note{font-size:12.5px;color:#8a7a9a;margin:12px 0 0} #astroya-ascendant-calc .asc-deep{margin:0 0 24px;padding:26px 22px;background:#fff;border:1px solid rgba(184,132,155,.3);border-radius:10px;box-shadow:0 10px 30px rgba(107,76,138,.1);animation:fadeInUp .8s ease} #astroya-ascendant-calc .asc-deep-head{text-align:center;margin-bottom:14px} #astroya-ascendant-calc .asc-deep-title{font-family:'El Messiri',Georgia,serif;font-weight:700;font-size:30px;color:#3d2c5a} #astroya-ascendant-calc .asc-deep-tags{display:flex;flex-wrap:wrap;gap:6px;justify-content:center;margin:6px 0 10px} #astroya-ascendant-calc .asc-deep-tags span{font-size:13px;background:#f3e8f0;border-radius:20px;padding:4px 12px;color:#3d2c5a} #astroya-ascendant-calc .asc-deep-forces{font-size:15px;margin:0} #astroya-ascendant-calc .asc-deep-duo{background:linear-gradient(135deg,#faf0ea,#fdf9f3);border-left:3px solid #c9a96e;border-radius:0 8px 8px 0;padding:12px 16px;margin:0 0 12px;font-size:15px;color:#3a3a4d} #astroya-ascendant-calc .asc-deep-duo b{display:block;color:#6b4c8a;margin-bottom:3px} #astroya-ascendant-calc .asc-deep-decan{border-left-color:#b8849b} #astroya-ascendant-calc .asc-deep-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-top:4px} #astroya-ascendant-calc .asc-deep-sec{background:#faf7f2;border:1px solid rgba(184,132,155,.2);border-radius:8px;padding:14px 16px;transition:transform .25s,box-shadow .25s} #astroya-ascendant-calc .asc-deep-sec:hover{transform:translateY(-3px);box-shadow:0 10px 24px rgba(107,76,138,.1)} #astroya-ascendant-calc .asc-deep-sec-t{font-weight:700;color:#6b4c8a;font-size:15px;margin-bottom:4px} #astroya-ascendant-calc .asc-deep-sec p{font-size:14.5px;margin:0} #astroya-ascendant-calc .asc-deep-mantra{margin-top:14px;text-align:center;background:linear-gradient(135deg,#3d2c5a,#6b4c8a 55%,#b8849b);color:#fff;border-radius:10px;padding:18px} #astroya-ascendant-calc .asc-deep-mantra span{font-size:12px;letter-spacing:.2em;text-transform:uppercase;opacity:.85} #astroya-ascendant-calc .asc-deep-mantra p{color:#fff;font-style:italic;font-size:17px;margin:6px 0 0} @media (max-width:640px){#astroya-ascendant-calc .asc-deep-grid{grid-template-columns:1fr}#astroya-ascendant-calc h2{font-size:24px}#astroya-ascendant-calc .asc-lock-title{font-size:19px} }";
  (function(){ if($('asc-mstyle')) return; var st=document.createElement('style'); st.id='asc-mstyle'; st.appendChild(document.createTextNode(CSS)); (document.head||document.documentElement).appendChild(st); })();

  function scrollToWithOffset(el){
    if(!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - SCROLL_OFFSET; if(y < 0) y = 0;
    try{ window.scrollTo({top:y, behavior:'smooth'}); }catch(e){ window.scrollTo(0, y); }
  }
  function showError(msg){
    var errorEl = $('calc-error'); if(!errorEl) return;
    errorEl.textContent = msg; errorEl.classList.add('active');
    if(errorEl.scrollIntoView){ errorEl.scrollIntoView({behavior:'smooth', block:'center'}); }
  }

  var current = null, revealId = 0, busy = false;

  function revealAscendant(){
    var dateEl = $('birth-date'), timeEl = $('birth-time'), latEl = $('birth-lat'), cityEl = $('birth-city-search');
    var errorEl = $('calc-error'), btn = $('btn-calc'), loading = $('calc-loading'), result = $('result-wrapper');
    if(busy) return;
    if(errorEl){ errorEl.classList.remove('active'); errorEl.textContent = ''; }
    if(!dateEl || !dateEl.value){ showError('Indique ta date de naissance.'); return; }
    if(!timeEl || !timeEl.value){ showError('Indique ton heure de naissance pr\u00e9cise : elle figure sur ton acte de naissance.'); return; }
    if(!latEl || !latEl.value){
      if(cityEl && cityEl.value.trim()){ showError('Choisis ta ville dans la liste qui s\'affiche sous le champ.'); }
      else { showError('Indique ta ville de naissance, puis s\u00e9lectionne-la dans la liste.'); }
      if(cityEl && cityEl.focus){ cityEl.focus(); }
      return;
    }
    var lngEl = $('birth-city-lng'), tzEl = $('birth-city-tz');
    var r = computeAscendant(dateEl.value, timeEl.value, parseFloat(latEl.value), lngEl ? lngEl.value : '', tzEl ? tzEl.value : '');

    /* Transmission du SIGNE SOLAIRE au panel "Mon Astroya" */
    try{ if(window.MonAstroya && typeof window.MonAstroya.setSigne === 'function'){ var sn = SIGNS[r.sun].name; window.MonAstroya.setSigne(sn, sn.toLowerCase()); } }catch(e){}
    /* Evenement pour tout module externe (analytics, panel...) */
    try{
      var nameEl = $('birth-city-name'), payEl = $('birth-city-country');
      document.dispatchEvent(new CustomEvent('astroya:ascendant-ready', { detail: {
        ascendant: SIGNS[r.asc].name, signeSolaire: SIGNS[r.sun].name, degre: r.deg,
        ville: nameEl ? nameEl.value : '', pays: payEl ? payEl.value : '',
        lat: parseFloat(latEl.value), lng: lngEl && lngEl.value ? parseFloat(lngEl.value) : null } }));
    }catch(e){}

    busy = true; if(btn) btn.disabled = true;
    if(result) result.classList.remove('active');
    if(loading) loading.classList.add('active');
    setTimeout(function(){
      if(loading) loading.classList.remove('active');
      displayResult(r);
      busy = false; if(btn) btn.disabled = false;
    }, 1800);
  }

  function displayResult(r){
    var asc = SIGNS[r.asc], i, h = '';
    var nameC = $('birth-city-name'), payC = $('birth-city-country');
    current = { asc: r.asc, sun: r.sun, deg: r.deg, ville: nameC ? nameC.value : '', pays: payC ? payC.value : '' };
    var symEl = $('result-symbol');
    if(symEl) symEl.innerHTML = '<img src="' + asc.image + '" alt="Ascendant ' + asc.name + ' \u2014 visuel \u00e9ditorial Astroya" loading="lazy" width="320" height="320">';
    var nm = $('result-name'); if(nm) nm.textContent = 'Ascendant ' + asc.name;
    var el = $('result-element'); if(el) el.textContent = '\u00c9l\u00e9ment ' + asc.element + (r.precise ? ' \u00b7 ' + formatDeg(r.lon) : '') + ' \u00b7 Soleil en ' + SIGNS[r.sun].name;
    var de = $('result-description');
    if(de){ var parts = asc.desc.split('|'); for(i = 0; i < parts.length; i++){ h += '<p>' + parts[i] + '</p>'; } de.innerHTML = h; }
    var st = $('result-stones'); if(st) st.textContent = asc.stones;
    var ct = $('result-cta-link'); if(ct) ct.textContent = 'D\u00e9couvrir les pierres ascendant ' + asc.name + ' \u2726';
    var lt = $('asc-lock-title'); if(lt) lt.textContent = 'Tout sur ton ascendant ' + asc.name;
    var deep = $('asc-deep'), lock = $('asc-lock');
    if(deep){ deep.hidden = true; deep.innerHTML = '\u200B'; }
    if(lock){ lock.hidden = false; lock.classList.remove('asc-checking'); }
    var res = $('result-wrapper');
    if(res){ res.classList.add('active'); setTimeout(function(){ scrollToWithOffset(res); }, 200); }
    astroyaTrack('tool_result', { tool_name:'ascendant', ascendant: asc.name, signe: SIGNS[r.sun].name, precis: r.precise ? 'oui' : 'non' });
    tryReveal();
  }

  function renderDeep(d){
    var box = $('asc-deep'), lock = $('asc-lock'), i, h = '';
    if(!box || !current || d.asc !== current.asc || d.sun !== current.sun) return;
    h += '<div class="asc-deep-head"><div class="asc-deep-eyebrow">\u2726 Ta lecture d\u00e9taill\u00e9e \u2726</div>';
    h += '<div class="asc-deep-title">Ascendant ' + esc(d.name) + '</div>';
    h += '<div class="asc-deep-tags"><span>Ma\u00eetre : ' + esc(d.maitre) + '</span><span>Soleil en ' + esc(d.sunName) + '</span></div>';
    h += '<p class="asc-deep-forces"><b>Tes forces :</b> ' + esc(d.forces) + '</p></div>';
    h += '<div class="asc-deep-duo"><b>Ton duo Soleil \u00d7 Ascendant</b>' + esc(d.duo) + '</div>';
    if(d.decan) h += '<div class="asc-deep-duo asc-deep-decan"><b>Ton d\u00e9can</b>' + esc(d.decan) + '</div>';
    h += '<div class="asc-deep-grid">';
    for(i = 0; i < (d.sections || []).length; i++){ h += '<div class="asc-deep-sec"><div class="asc-deep-sec-t">' + esc(d.sections[i].icon) + ' ' + esc(d.sections[i].title) + '</div><p>' + esc(d.sections[i].text) + '</p></div>'; }
    h += '</div><div class="asc-deep-mantra"><span>Ton mantra</span><p>' + esc(d.mantra) + '</p></div>';
    box.innerHTML = h; box.hidden = false; if(lock) lock.hidden = true;
  }
  function payload(action, extra){
    var p = { action: action, asc: current.asc, sun: current.sun, deg: current.deg };
    for(var k in extra){ if(extra.hasOwnProperty(k)) p[k] = extra[k]; }
    return p;
  }
  function tryReveal(){
    var my = ++revealId, auth = getAuth(), lock = $('asc-lock');
    if(!auth.email || !current) return;
    if(lock) lock.classList.add('asc-checking');
    ask(payload('reveal', { email: auth.email, token: auth.token })).then(function(d){
      if(my !== revealId) return; if(lock) lock.classList.remove('asc-checking'); saveAuth(auth.email, d.token || auth.token); renderDeep(d);
    }, function(){ if(my !== revealId) return; if(lock) lock.classList.remove('asc-checking'); });
  }

  /* ---------- POPUP 2 ECRANS ---------- */
  var sending = false;
  function popStep(n){ var f=$('hpm-form'), s=$('hpm-ok'); if(f) f.hidden=(n!==1); if(s) s.hidden=(n!==2); }
  function popError(msg){ var e=$('hpm-err'); if(!e) return; if(!msg){ e.classList.remove('hpm-show'); e.innerHTML='&#8203;'; return; } e.textContent=msg; e.classList.add('hpm-show'); }
  function openPop(){
    var mEl=$('hpm'); if(!mEl || !current) return; popStep(1); popError('');
    var em=$('hpm-email'); if(em && !em.value) em.value=knownEmail();
    var sub=$('hpm-sub'); if(sub) sub.textContent='Portrait, amour, travail, d\u00e9can, duo Soleil \u00d7 Ascendant et mantra de ton ascendant ' + SIGNS[current.asc].name + ', offerts avec la newsletter Astroya.';
    mEl.classList.add('hpm-open'); mEl.setAttribute('aria-hidden','false'); document.body.classList.add('hpm-lock');
    if(window.innerWidth>700){ setTimeout(function(){ var i=$('hpm-email'); if(i) i.focus(); },200); }
  }
  function closePop(){ var mEl=$('hpm'); if(!mEl) return; mEl.classList.remove('hpm-open'); mEl.setAttribute('aria-hidden','true'); document.body.classList.remove('hpm-lock'); }
  function submitPop(){
    if(sending || !current) return;
    var emEl=$('hpm-email'), cb=$('hpm-consent'), btn=$('hpm-submit');
    var email=emEl?(emEl.value||'').trim().toLowerCase():'';
    if(!/^[^\s@"\\]+@([a-z0-9]([a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i.test(email)){ popError('Cette adresse e-mail semble incorrecte. V\u00e9rifie-la et r\u00e9essaie.'); if(emEl) emEl.focus(); return; }
    if(!cb||!cb.checked){ popError('Coche la case pour recevoir ta lecture d\u00e9taill\u00e9e.'); var lab=document.querySelector('#hpm .hpm-consent'); if(lab){ lab.classList.add('hpm-invalid'); setTimeout(function(){ lab.classList.remove('hpm-invalid'); },600); } return; }
    popError(''); sending=true; if(btn){ btn.disabled=true; btn.textContent='Envoi\u2026'; }
    function restore(){ sending=false; if(btn){ btn.disabled=false; btn.textContent='Lire ma lecture d\u00e9taill\u00e9e'; } }
    var my = ++revealId;
    ask(payload('subscribe', { email: email, consent: true, ville: current.ville, pays: current.pays })).then(function(d){
      saveAuth(email, d.token); if(my === revealId) renderDeep(d); popStep(2); restore();
      astroyaTrack('email_capture', { tool_name:'ascendant', capture_type:'email_only', ascendant: SIGNS[current.asc].name });
    }, function(err){
      var c=err&&err.code;
      popError(c==='email'?'Cette adresse e-mail semble incorrecte. V\u00e9rifie-la et r\u00e9essaie.':c==='klaviyo'?'L\u2019inscription n\u2019a pas pu aboutir. R\u00e9essaie dans un instant.':'Connexion interrompue. V\u00e9rifie ton r\u00e9seau et r\u00e9essaie.');
      restore();
    });
  }

  function boot(){
    var root = $('astroya-ascendant-calc');
    if(!root) return false;
    if(root.getAttribute('data-asc-init') === '1') return true;
    root.setAttribute('data-asc-init', '1'); window.__astroyaAscV2 = true;
    (function(){ var pm=$('hpm'); if(pm && pm.parentNode!==document.body) document.body.appendChild(pm); })();
    try{ sessionStorage.setItem('astroya_tool','ascendant'); }catch(e){}
    astroyaTrack('tool_view', { tool_name:'ascendant' });
    window.revealAscendant = revealAscendant;
    document.addEventListener('click', function(ev){
      var t=ev.target; if(!t||!t.closest) return;
      if(t.closest('#btn-calc')){ ev.preventDefault(); revealAscendant(); return; }
      if(t.closest('#asc-unlock')){ ev.preventDefault(); openPop(); return; }
      if(t.closest('#hpm-close')||t.closest('#hpm-overlay')){ closePop(); return; }
      if(t.closest('#hpm-submit')){ ev.preventDefault(); submitPop(); return; }
      if(t.closest('#hpm-continue')){ closePop(); scrollToWithOffset($('asc-deep')); return; }
    }, false);
    document.addEventListener('keydown', function(ev){
      var mEl=$('hpm'); if(!mEl||!mEl.classList.contains('hpm-open')) return;
      if(ev.key==='Escape') closePop(); else if(ev.key==='Enter'&&ev.target&&ev.target.id==='hpm-email'){ ev.preventDefault(); submitPop(); }
    }, false);
    return true;
  }
  /* API publique (tests en console) */
  window.AstroyaAscendant = { compute: computeAscendant };

  var tries = 0, iv = setInterval(function(){ tries++; if(boot() || tries >= 40){ clearInterval(iv); } }, 150);
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  window.addEventListener('load', boot);
})();
} catch(error){console.error(error);}